import React, { useState } from 'react'
// import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

// Components
import Tip from '@/components/common/Tip'
import HelpFormik from './components/HelpFormik'
import HelpForm from './components/HelpForm'
import CheckIcon from '@/assets/svg/check.svg'
import RedsoIcon from '@/assets/images/redso.png'
import BoutirIcon from '@/assets/images/boutir.png'
import white from '@/assets/images/bottom-white@3x.png'

// Lib MISC
import styles from './style.scss'
import words from "@/assets/worddict.json"

const cx = classnames.bind(styles)

export const propTypes = {}

function Help ({ lang }) {
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [isSucceeded, setIsSucceeded] = useState(false)

  const $t = words[lang]

  return (
    <div className={cx('help')}>
      <div className={cx('help-wrapper')}>
        <Tip className={cx('help-wrapper-tip')} tipClassName={cx('help-wrapper-tip-item')} img={white} />
        <div className={cx('help-wrapper__content')}>
          <p className={cx('help-wrapper__content-title')}>{$t.TXT_Help_title}</p>
          <p className={cx('help-wrapper__content-description')}>{$t.TXT_Help_description}</p>
          <div className={cx('help-wrapper__content-item')}>
            <img className={cx('help-wrapper__content-item-icon')} src={CheckIcon} />
            <p className={cx('help-wrapper__content-item-text')}>{$t.TXT_Help_content1}</p>
          </div>
          <div className={cx('help-wrapper__content-item')}>
            <img className={cx('help-wrapper__content-item-icon')} src={CheckIcon} />
            <p className={cx('help-wrapper__content-item-text')}>{$t.TXT_Help_content2}</p>
          </div>
          <div className={cx('help-wrapper__content-item')}>
            <img className={cx('help-wrapper__content-item-icon')} src={CheckIcon} />
            <p className={cx('help-wrapper__content-item-text')}>{$t.TXT_Help_content3}</p>
          </div>
          <div className={cx('help-wrapper__content-trust')}>
            <p className={cx('help-wrapper__content-trust-title')}>{$t.TXT_Help_trust_by_clients}</p>
            <div className={cx('help-wrapper__content-trust-icon')}>
              <img className={cx('help-wrapper__content-trust-icon-item', 'redso')} src={RedsoIcon} />
              <img className={cx('help-wrapper__content-trust-icon-item', 'boutir')} src={BoutirIcon} />
            </div>
          </div>
        </div>
        <HelpFormik setIsSubmitted={setIsSubmitted} setIsSucceeded={setIsSucceeded} $t={$t}>
          <HelpForm isSubmitted={isSubmitted} isSucceeded={isSucceeded} $t={$t} />
        </HelpFormik>
      </div>
    </div>
  )
}

Help.propTypes = propTypes

export default Help
